var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-form-model',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules}},[_c('a-form-model-item',{attrs:{"has-feedback":"","label":"Title / Tiêu đề","prop":"name"}},[_c('a-input',{attrs:{"placeholder":"Enter title"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_c('a-form-model-item',{attrs:{"has-feedback":"","label":"Main Shift / Ca làm việc chính","prop":"mainShiftId"}},[_c('SelectWorkShift',{attrs:{"initial-datas":_vm.form.mainShift ? [_vm.form.mainShift] : null,"select-props":{
          placeholder: 'Choose shift',
          value: _vm.form.mainShiftId,
        },"variables-query":{
          isOvertime: false,
        }},model:{value:(_vm.form.mainShiftId),callback:function ($$v) {_vm.$set(_vm.form, "mainShiftId", $$v)},expression:"form.mainShiftId"}})],1)],1),_c('div',{staticStyle:{"text-align":"right"},style:({
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1,
    })},[_c('a-button',{staticStyle:{"margin-right":"5px"},attrs:{"icon":"close"},on:{"click":_vm.closeDrawerAdd}},[_vm._v(" Close ")]),_c('a-button',{attrs:{"type":"primary","loading":_vm.iconLoading,"icon":"plus"},on:{"click":function($event){return _vm.create()}}},[_vm._v(" Create ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }